import { downloadPdfFromBlobResponse } from 'helpers/pdf';

import { axios } from 'shared';
import { Payment } from 'store/Tenancy/types';

export function getPayments({ tenancyId }: { tenancyId: number }) {
  return axios.get<Payment[]>(`/v2/tenancies/${tenancyId}/payments`);
}

export function getFailedPayments({ tenancyId }: { tenancyId: number }) {
  return axios.get<Payment[]>(`/v2/tenancies/${tenancyId}/payments/failed`);
}

export function downloadPaymentSummary({ tenancyId, paymentId }: { tenancyId: number; paymentId: number }) {
  return axios({
    url: `/v2/tenancies/${tenancyId}/payments/${paymentId}`,
    method: 'GET',
    responseType: 'blob'
  }).then(response => {
    downloadPdfFromBlobResponse(response);
  });
}
